import { render, staticRenderFns } from "./TemplateDetailsCampaigns.vue?vue&type=template&id=06323ce6&scoped=true&"
import script from "./TemplateDetailsCampaigns.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailsCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetailsCampaigns.vue?vue&type=style&index=0&id=06323ce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06323ce6",
  null
  
)

export default component.exports